/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import CloseAction from './CloseAction/index'
import Filters from './Filters/index'
import FiltersAction from './FiltersAction/index'
import ModalFullScreen from 'DesignSystem/ModalFullScreen/index'
import Profiles from './Profiles/index'
import React from 'react'
import SearchTermInput from './SearchTermInput/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonText from 'DesignSystem/TysiaButton/TysiaButtonText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Professionals/AddAction/Search/Content"
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
  return (<React.Fragment
>
<ModalFullScreen
  viewPath={`${viewPath}/ModalFullScreen`}
 paddingBottom={0}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<SearchTermInput
  viewPath={`${viewPath}/SearchTermInput`}
/>
<FiltersAction
  viewPath={`${viewPath}/FiltersAction`}
/>
<CloseAction
  viewPath={`${viewPath}/CloseAction`}
/>
</div>
<Filters
  viewPath={`${viewPath}/Filters`}
/>
</div>
<Profiles
  viewPath={`${viewPath}/Profiles`}
/>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pb-1-Z1Yf8zk': typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Horizontal1}`}
>
<TysiaButton
  viewPath={`${viewPath}/TysiaButton`}
 type="secondary"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../New/Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, '../../New/Content'))}
>
{childProps => (
<TysiaButtonText
{...childProps}
  viewPath={`${viewPath}/TysiaButtonText`}
 text="Create New Professional"
/>
)}
</TysiaButton>
</div>
</div>
)}
</ModalFullScreen>
{children}
</React.Fragment>)
}